export default __webpack_public_path__ + "static/media/p2-min.bf6abd3f.png";